// only import this if you are using the ag-Grid-Enterprise
import {observable} from "aurelia-framework";
//import 'ag-grid-enterprise/main';

export class AnimationDemo {
    columnDefs = [
        { headerName: "Make", field: "make", filter: 'text' },
        { headerName: "Model", field: "model" },
        { headerName: "Price", field: "price", filter: 'number' }
    ];

    rowData = [
        { make: "Toyota", model: "Celica", price: 35000 },
        { make: "Ford", model: "Mondeo", price: 32000 },
        { make: "Porsche", model: "Boxter", price: 72000 }
    ];

    load() {
        this.rowData = [
            { make: "Toyota", model: "Celica", price: 35000 },
            { make: "Ford", model: "Mondeo", price: 32000 },
            { make: "Porsche", model: "Boxter", price: 72000 }
        ];
    }

    @observable
    filter: string;

    @observable
    brandFilter: string;

    brandFilterChanged() {
        var nameFilter = this.gridOptions.api.getFilterInstance('make');
        nameFilter.setType('equals');
        nameFilter.setFilter(this.brandFilter);
        this.gridOptions.api.onFilterChanged();
}

    filterChanged() {
        this.gridOptions.api.setQuickFilter(this.filter);
    }


    export() {
        this.gridOptions.api.exportDataAsCsv({
            fileName: "test.xls"
        });
    }

    gridOptions = {
        api: undefined,
        columnDefs: this.columnDefs,
        rowData: this.rowData
    };

    onModelUpdated() {
        console.log('onModelUpdated');
        //this.calculateRowCount();
    };
    onReady() {
        console.log('onReady');
        //this.calculateRowCount();
    };
    onCellClicked($event) {
        console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    };
    onCellValueChanged($event) {
        console.log('onCellValueChanged: ' + $event.oldValue + ' to ' + $event.newValue);
    };
    onCellDoubleClicked($event) {
        console.log('onCellDoubleClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    };
    onCellContextMenu($event) {
        console.log('onCellContextMenu: ' + $event.rowIndex + ' ' + $event.colDef.field);
    };
    onCellFocused($event) {
        console.log('onCellFocused: (' + $event.rowIndex + ',' + $event.column ? $event.column.colId : '' + ')');
    };
    onRowSelected($event) {
    };
    onSelectionChanged() {
        console.log('selectionChanged');
    };
    onBeforeFilterChanged() {
        console.log('beforeFilterChanged');
    };
    onAfterFilterChanged() {
        console.log('afterFilterChanged');
    };
    onFilterModified() {
        console.log('onFilterModified');
    };
    onBeforeSortChanged() {
        console.log('onBeforeSortChanged');
    };
    onAfterSortChanged() {
        console.log('onAfterSortChanged');
    };
    onVirtualRowRemoved($event) {
    };
    onRowClicked($event) {
        console.log('onRowClicked: ' + $event.node.data.name);
    };
    onQuickFilterChanged($event) {
        console.log('onQuickFilterChanged: ' + $event.target.value);
        //this.gridOptions.api.setQuickFilter($event.target.value);
    };
    onColumnEvent($event) {
        console.log('onColumnEvent: ' + $event);
    };
    onIdClicked(row) {
        console.log('id clicked ' + row.id);
    };

}